<template>
  <modal-fullscreen
    v-if="visible"
    title="Request payment"
    :visible="visible"
    width="1000px"
    wrap-class-name="request-payment-modal"
    data-testid="request-payment-modal"
    @cancel="closeModal"
  >
    <a-steps :current="step" size="small" class="request-payment-steps">
      <a-step title="Select Shifts" />
      <a-step title="Payment System" />
      <a-step title="Review Request" />
    </a-steps>

    <request-payment-select-shifts
      v-if="step === 0"
      ref="selectShifts"
      :initial-client-id="initialValues?.client_id"
      @created="openPaymentSystem"
      @state-change="setStepState(0, $event)"
    />
    <request-payment-system
      v-else-if="step === 1"
      ref="paymentSystem"
      :payment-id="requestId"
      @processed="openReview"
      @state-change="setStepState(1, $event)"
    />
    <request-payment-review
      v-else
      ref="review"
      :payment-id="requestId"
      @completed="completeRequest"
      @state-change="setStepState(2, $event)"
    />

    <template #footer>
      <div class="request-payment-footer">
        <a-button :disabled="stepState.loading" @click="closeModal">Close</a-button>
        <a-button
          type="primary"
          :loading="stepState.loading"
          :disabled="!stepState.canContinue"
          @click="continueStep"
        >
          {{ stepState.label }}
        </a-button>
      </div>
    </template>
  </modal-fullscreen>
</template>

<script>
import { Button, Steps } from 'ant-design-vue'
import RequestPaymentSelectShifts from './request-payment-select-shifts.vue'
import RequestPaymentSystem from './request-payment-system.vue'
import RequestPaymentReview from './request-payment-review.vue'

const createStepState = () => ({
  canContinue: false,
  loading: false,
  label: 'Continue'
})

export default {
  components: {
    'a-button': Button,
    'a-steps': Steps,
    'a-step': Steps.Step,
    'request-payment-select-shifts': RequestPaymentSelectShifts,
    'request-payment-system': RequestPaymentSystem,
    'request-payment-review': RequestPaymentReview
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    initialPaymentId: {
      type: Number,
      default: null
    },
    initialStep: {
      type: Number,
      default: 0
    },
    initialValues: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      step: 0,
      requestId: null,
      stepState: createStepState()
    }
  },
  watch: {
    visible: {
      handler(isVisible) {
        if (!isVisible) return
        this.step = this.initialPaymentId ? this.initialStep : 0
        this.requestId = this.initialPaymentId
        this.stepState = createStepState()
      },
      immediate: true
    }
  },
  methods: {
    setStepState(step, state) {
      if (this.step !== step) return
      this.stepState = { ...createStepState(), ...state }
    },
    continueStep() {
      if (this.step === 0) this.$refs.selectShifts.createRequest()
      else if (this.step === 1) this.$refs.paymentSystem.processPayment()
      else this.$refs.review.confirmTransfer()
    },
    openPaymentSystem(requestId) {
      this.requestId = requestId
      this.step = 1
      this.stepState = createStepState()
    },
    openReview() {
      this.step = 2
      this.stepState = createStepState()
    },
    completeRequest() {
      this.$emit('completed')
      this.$emit('update:visible', false)
    },
    closeModal() {
      if (this.stepState.loading) return
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped>
.request-payment-steps {
  max-width: 720px;
  margin: 0 auto 24px;
}
.request-payment-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
::v-deep .request-payment-modal.modal-fullscreen-wrap--expanded .ant-modal-body {
  padding-bottom: 12px;
}
</style>
